module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.0b76306.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/roboto/Roboto-Medium.otf
// module id = MMFS
// module chunks = 0